import {Injectable} from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {UrlUtils} from '../../shared/utils/url.utils';


@Injectable({
    providedIn: 'root',
})
export class ProfileOutputResolverService  {

    institutionCode: string;

    constructor() {
        this.institutionCode = UrlUtils.getParam('institution');
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>{
        const id = route.paramMap.get('id');
        return of(id);
    }
}

